import { NAME } from "./constants";

const select = key => state => state[NAME][key];

export const isCollapsed = select("isCollapsed");
